export default __webpack_public_path__ + "static/media/arrow.227bccaa.png";